// src/features/infoscreens/pages/InfoscreenShowPage/components/TasksCardView.jsx
import React from 'react';
import { Box } from '@mui/material';
import TaskCard from '../../../../tasks/components/TaskCard';

export default function TasksCardView({ tasks }) {
  // Empty handlers for TaskCard (read-only mode)
  const handleView = () => {};
  const handleEdit = () => {};
  const handleDelete = () => {};
  const handleStateChange = () => {};

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(auto-fill, minmax(400px, 1fr))"
      gap={3}
    >
      {tasks.map((task) => (
        <TaskCard
          key={task.task_id}
          task={task}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onStateChange={handleStateChange}
          canEdit={false}
          canDelete={false}
          canChangeState={false}
          hideContextMenu={true}
        />
      ))}
    </Box>
  );
}